export const GOOGLE_CHART_AREA = 'google-chart-area';
export const CROSS_TAB_CHART_AREA = 'cross-tab-chart-area';
